import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=bb0c8c78&scoped=true&"
var script = {}
import style0 from "./Modal.vue?vue&type=style&index=0&id=bb0c8c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c8c78",
  null
  
)

export default component.exports